import InvestExportsPageNew from './InvestExportsPageNew';

export default InvestExportsPageNew;
